import { createSlice } from '@reduxjs/toolkit'; 

export interface IAddress {
  streetAndNumber: string;
  place: string;
  region: string;
  postcode: string;
  country: string;
  latitude: number;
  longitude: number;
}

export interface AddressInitialState {
  selectedAddress: IAddress | null;
  isAddressClicked: boolean;
  loading: boolean;
  error: string;
  success: boolean;
}

const initialState: AddressInitialState = {
  selectedAddress: null,
  isAddressClicked: false,
  loading: false,
  error: '',
  success: false,
};

export const AddressSlice = createSlice({
  name: 'addressSlice',
  initialState,
  reducers: {
    setSelectedAddress: (state, action) => {
      state.selectedAddress = action.payload;
    },
    setIsAddressClicked: (state, action) => {
      state.isAddressClicked = action.payload;
    },
  },
});

export const AddressActions = {
  ...AddressSlice.actions,
};

export const AddressReducer = AddressSlice.reducer;
